<div class="performance-card">
    <div class="performance-card-icon">
        <i [class]="icon"></i>
    </div>
    <div class="performance-card-content">
        <div class="performance-card-value">
            @if(type == "resource") {
                {{count | currency:'AED'}}
            } @else {
                <span [countUp]="count" [duration]="2000"></span>
            }
        </div>
        <div class="performance-card-label">
            {{name}}
        </div>
    </div>
</div>
